<template>
  <v-autocomplete
    v-model="selected"
    :items="selectorOptions"
    :loading="loading"
    :label="single ? 'Договор' : 'Договоры'"
    item-value="id"
    item-text="number"
    :search-input.sync="search"
    no-data-text="Ничего не найдено"
    prepend-inner-icon="mdi mdi-reload mdi-18px"
    no-filter
    multiple
    :rules="rule"
    :disabled="disabled"
    @click:prepend-inner="refresh"
  >
    <!-- Чипсы в инпуте -->
    <template #selection></template>
    <template #append>
      <span v-if="selected.length <= 1" class="mr-2 mt-n1" style="max-width: 130px;">
        <v-chip small v-for="selectedId in selected" :key="`contracts_selector${selectedId}`" >
          <span class="sliced-name">{{ getName(selectedId) }}</span>
        </v-chip>
      </span>

      <span v-else class="mt-n1">
        <v-chip small style="max-width: 130px;">
          <span class="sliced-name">{{ getName(selected[0]) }}</span>
        </v-chip>
        <span class="grey--text caption">(+{{selected.length - 1}})</span>
      </span>
    </template>

    <!-- Убираем чекбоксы в меню -->
    <template #item="data">
      <template>
        <v-list-item-content>
          <v-list-item-title v-html="data.item.number"></v-list-item-title>
        </v-list-item-content>
      </template>
    </template>

    <!-- Строка "Выбрать всё" -->
    <template #prepend-item>
      <v-list-item v-if="single === false" ripple @click="toggleAll">
        <v-list-item-action>
          <v-icon>
            {{ icon }}
          </v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{toggleAllText}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider v-if="single === false" class="mt-2"></v-divider>
    </template>
  </v-autocomplete>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ContractSelector',
  props: {
    value: {
      required: true,
    },
    single: {
      type: Boolean,
      default: false,
    },
    selectedAll: Boolean,
    noRules: Boolean,
    disabled: Boolean,
  },

  data() {
    return {
      allSelectorOptions: [],
      selectorOptions: [],
      loading: true,
      search: null,
      rule: [
        v => {
          if (this.noRules || this.disabled) return true
          else {
            return !!v.length || 'Данное поле обязательно'
          }
        }
      ],
      debounceRequest: null,
    }
  },

  computed: {
    ...mapGetters({
      allContracts: 'graphql/allContracts',
    }),

    selected: {
      get() {
        return this.value
      },
      set(selected) {
        this.$emit('input', selected)
      },
    },

    allItems() {
      return this.selected.length === this.selectorOptions.length
    },

    moreItems() {
      return this.selected.length > 0 && !this.allItems
    },

    icon() {
      if (this.allItems) return 'mdi-close-box'
      if (this.moreItems) return 'mdi-plus-box'
      return 'mdi-checkbox-blank-outline'
    },

    toggleAllText() {
      if (this.allItems) return 'Отменить все'
      if (this.moreItems) return 'Выбрать все'
      return 'Выбрать все'
    },
  },

  watch: {
    selected(val) {
      if (this.single) {
        if (val.length > 1) this.value.shift()
      }
    },

    search(val) {
      if (this.debounceRequest == null) return
      this.debounceRequest(val)
    },
  },

  methods: {
    ...mapActions({
      loadAllContracts: 'graphql/loadAllContracts',
      loadContracts: 'graphql/loadContracts',
    }),

    toggleAll() {
      this.$nextTick(() => {
        if (this.allItems) {
          this.selected = []
        } else {
          this.selected = this.selectorOptions.map((p) => p.id)
        }
      })
    },

    find(val) {
      this.loading = true
      let graphQuery = {
        query: `{
          Contracts(search: "${val || ''}") {
            data {
              id
              number
            }
          }
        }`
      }
      this.loadContracts(graphQuery)
        .then(res => {this.selectorOptions = res})
        .finally(() => {this.loading = false})
    },

    async refresh() {
      this.selected = []
      this.search = ''
      this.loading = true
      await this.loadAllContracts()
      this.loading = false
    },

    getName(selectedId) {
      const selected = this.allSelectorOptions.find(p => p.id === selectedId)

      if (selected) return selected.number
      else return ''
    },
  },

  async mounted() {
    this.debounceRequest = this.utils.debounce(this.find, 700)
    await this.loadAllContracts()
    this.selectorOptions = this.allContracts
    this.allSelectorOptions = this.allContracts

    if (this.selectedAll || this.allSelectorOptions.length === 1) {
      this.selected = this.allSelectorOptions.map(p => p.id)
    }
    this.loading = false
  }
}
</script>

<style scoped lang="scss">
.sliced-name {
	width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
</style>